// JS dependency
var slick = require('jquery-zoom');

$('#slick-product').find( '.zoom-wp' ).each(function () {
    $(this).zoom();
});
